module.exports = __webpack_public_path__ + "static/bany_chernay-ce09bac9a3c0e19f936e2a53f215efcb.webp";